import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import { lazy } from "react";
import type {
	ClearButtonProps,
	SubmitButtonProps,
} from "../tanstack-form/actions";

export const { fieldContext, useFieldContext, formContext, useFormContext } =
	createFormHookContexts();

/**
 * Action Components
 */
const ClearButton: React.LazyExoticComponent<
	React.ComponentType<ClearButtonProps>
> = lazy(() =>
	import("../tanstack-form/actions/ClearButton.tsx").then((m) => ({
		default: m.ClearButton,
	})),
);
const SubmitButton: React.LazyExoticComponent<
	React.ComponentType<SubmitButtonProps>
> = lazy(() =>
	import("../tanstack-form/actions/SubmitButton.tsx").then((m) => ({
		default: m.SubmitButton,
	})),
);
/**
 * Field Components
 */
const CheckboxField = lazy(
	() => import("../tanstack-form/fields/CheckboxField.tsx"),
);
const RadioField = lazy(() => import("../tanstack-form/fields/RadioField.tsx"));
const SelectField = lazy(
	() => import("../tanstack-form/fields/SelectField.tsx"),
);
const SwitchField = lazy(
	() => import("../tanstack-form/fields/SwitchField.tsx"),
);
const TextareaField = lazy(
	() => import("../tanstack-form/fields/TextareaField.tsx"),
);
const TextField = lazy(() => import("../tanstack-form/fields/TextField.tsx"));

export const defaultFieldComponents = {
	CheckboxField,
	RadioField,
	SelectField,
	SwitchField,
	TextareaField,
	TextField,
} as const;

export const defaultFormComponents = {
	ClearButton,
	SubmitButton,
} as const;

export const defaultBaseFormHook = createFormHook({
	fieldComponents: defaultFieldComponents,
	formComponents: defaultFormComponents,
	fieldContext,
	formContext,
});

export const { useAppForm, withForm } = defaultBaseFormHook;
